import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile from config
import 'webix/photo'; // Importing Webix photo module for image handling
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix for rich text editing

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Define the left section of the form with various input fields
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Make the field read-only
                    label:
                        "<span class='webix_icon icon-calendar'></span>" + // Icon for the label
                        _('Fecha'), // Localized label text
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker input
                    name: 'Date',
                    id: 'Date',
                    stringResult: true, // Return date as a string
                    minWidth: 200,
                    label:
                        "<span class='webix_icon icon-calendar'></span>" + // Icon for the label
                        _('Fecha'), // Localized label text
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar', // Suggestion type
                        body: {
                            maxDate: new Date(), // Maximum selectable date is today
                        },
                    },
                },
                {
                    view: 'richselect', // Dropdown for selecting bet type
                    name: 'TypeBet',
                    label: _('Tipo de Apuesta'), // Localized label text
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar'), // Placeholder text
                    value: 2, // Default selected value
                    options: [
                        // Options for the dropdown
                        { id: '1', value: _('Apuestas Creadas') },
                        { id: '2', value: _('Apuestas Cerradas') },
                        { id: '3', value: _('Apuestas Pagadas') },
                    ],
                },
                {
                    view: 'radio', // Radio buttons for deletion option
                    name: 'Delete',
                    label: _('Con Eliminadas?'), // Localized label text
                    labelPosition: 'top',
                    height: screen.width < 500 ? 150 : 0, // Conditional height based on screen width
                    value: 'N', // Default selected value
                    options: [
                        // Options for the radio buttons
                        { id: 'N', value: _('No') },
                        { id: 'S', value: _('Sí') },
                    ],
                },
            ],
        };
        // Define the center-left section of the form with additional input fields
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Ticket Id
                    name: 'Id',
                    label: "<span class='icon-ticket'></span>" + _('Ticket Id'), // Localized label text with icon
                    labelPosition: 'top',
                    placeholder: _('Ticket Id'), // Placeholder text
                },
                {
                    view: 'richselect', // Dropdown for selecting state
                    name: 'State',
                    localId: 'bonusStates:combo', // Local ID for reference
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label text with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        {
                            id: 'C',
                            value: _('Abierto'),
                        },
                        {
                            id: 'S',
                            value: _('Ganó'),
                        },
                        {
                            id: 'N',
                            value: _('Perdió'),
                        },
                        {
                            id: 'A',
                            value: _('No Acción'),
                        },
                        {
                            id: 'R',
                            value: _('Pendiente'),
                        },
                        {
                            id: 'W',
                            value: _('En Espera'),
                        },
                        {
                            id: 'J',
                            value: _('Rechazada'),
                        },
                        {
                            id: 'M',
                            value: _('Rechazada por Regla'),
                        },
                        {
                            id: 'T',
                            value: _('Retiro Voluntario'),
                        },
                    ],
                },
            ],
        };
        // Define the center-right section of the form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for test selection
                    name: 'IsTest',
                    localId: 'isTest:combo', // Local ID for reference
                    label: _('Es Test'), // Localized label text
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };
        // Define the right section of the form (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        // Define the upper section of the form layout
        const upper_section = {
            id: 'a1',
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 130 : 0, // Conditional height based on screen width
            rows: [
                {
                    responsive: 'a1', // Responsive layout identifier
                    margin: 10,
                    cols: [
                        left, // Include the left section
                        center_left, // Include the center-left section
                    ],
                },
            ],
        };
        // Define the buttons section with actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form fields
                    },
                },
                {
                    view: 'button', // Button to consult/filter data
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('betsReport:filter', [filterdata]); // Trigger filter event with data
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        // Define the accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        // Define a second buttons section for another form
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'), // Localized button text
                    click: () => {
                        $$('myForm2').clear(); // Clear the second form fields
                    },
                },
                {
                    view: 'button', // Button to consult/filter data for the second form
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Add country selection if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('betsReport:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };
        // Define a scrollable accordion section for the upper section
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        // Define a second accordion section for filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        // Define a popup window for filters
        const filterPopup = webix.ui({
            view: 'window', // Window component
            move: true, // Allow window to be moved
            id: 'filterPopup',
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the toolbar
                    {
                        view: 'icon', // Close icon for the window
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center the window on the screen
            body: {
                view: 'form', // Form inside the window
                id: 'myForm2', // ID for the form
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        // Return the main form structure
        return {
            type: 'clean',
            view: 'form',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Include accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder if screen size is insufficient
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function () {
            // Check if the profile typeDate is not equal to 2
            if (profile.typeDate !== 2) {
                // Hide the 'Date' element and show the 'Datepicker' element
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                // If the condition is true (always true in this case)
                if (true) {
                    // Show the 'Date' element and hide the 'Datepicker' element
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });

        // Retrieve the current language setting from the app's locale service
        const lang = this.app.getService('locale').getLang();

        // Attach an event handler for the 'onAfterRender' event of the 'Datepicker' element
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Set the date modal configuration based on the current language
            devConfig.setDateModal(lang);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
